export default __webpack_public_path__ + "ecd0ef08dd414f0d11ca39f1809ab4ba.png";